import React from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-16 pb-16 md:pt-24 md:pb-24 px-6 bg-white overflow-hidden border-b border-slate-100" data-id="element-179">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-180">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-50 border border-teal-100 text-teal-800 text-xs font-semibold uppercase tracking-wider mb-8" data-id="element-181">
          Editorially Independent D2D Analysis
        </div>

        <h1 className="text-4xl md:text-6xl font-bold text-slate-900 tracking-tight leading-[1.1] mb-6" data-id="element-182">
          The independent evaluation platform for{' '}
          <span className="text-teal-700" data-id="element-183">door-to-door</span>.
        </h1>

        <p className="text-lg md:text-xl text-slate-600 leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-184">
          Helping operators and reps understand tradeoffs before they pay the
          price.
        </p>

        {/* Search Bar */}
        <div className="max-w-xl mx-auto mb-6 relative" data-id="element-185">
          <div className="relative group" data-id="element-186">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-187">
              <Search className="h-5 w-5 text-slate-400 group-focus-within:text-teal-600 transition-colors" data-id="element-188" />
            </div>
            <input type="text" className="block w-full pl-11 pr-4 py-4 bg-white border border-slate-300 rounded-lg text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent shadow-sm transition-all" placeholder="Search guides, tools, industries..." data-id="element-189" />
            <div className="absolute inset-y-0 right-0 pr-2 flex items-center" data-id="element-190">
              <Link to="/guides" className="bg-slate-100 hover:bg-slate-200 text-slate-600 text-xs font-medium px-3 py-1.5 rounded-md transition-colors" data-id="element-191">
                Search
              </Link>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="flex flex-wrap justify-center gap-2 text-sm text-slate-500" data-id="element-192">
          <span className="mr-1" data-id="element-193">Popular:</span>
          {['Solar', 'Roofing', 'CRMs', 'Compensation', 'Work Models'].map(tag => <Link key={tag} to="/guides" className="px-3 py-1 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-full text-xs font-medium text-slate-600 transition-colors" data-id="element-194">
                {tag}
              </Link>)}
        </div>
      </div>
    </section>;
}